import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "modal__traffic-template-wrapper" }
const _hoisted_2 = {
  key: 0,
  class: "modal__traffic-info-item"
}
const _hoisted_3 = { class: "modal__traffic-info-label modal__subtitle" }
const _hoisted_4 = { class: "modal__traffic-info-value" }
const _hoisted_5 = {
  key: 1,
  class: "modal__traffic-info-item"
}
const _hoisted_6 = { class: "modal__traffic-info-label modal__subtitle" }
const _hoisted_7 = { class: "modal__traffic-info-value" }
const _hoisted_8 = {
  key: 2,
  class: "modal__traffic-no-data"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_translated_text_component = _resolveComponent("translated-text-component")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      (_ctx.modalData.last_status && _ctx.modalData.last_status.avg_speed)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_translated_text_component, { translation: "traffic_avg_speed" }),
              _cache[0] || (_cache[0] = _createTextVNode(": "))
            ]),
            _createElementVNode("div", _hoisted_4, _toDisplayString(Math.round(_ctx.modalData.last_status.avg_speed)) + " km/h ", 1)
          ]))
        : _createCommentVNode("", true),
      (_ctx.modalData.last_status && _ctx.modalData.last_status.avg_time)
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              _createVNode(_component_translated_text_component, { translation: "traffic_avg_time" }),
              _cache[1] || (_cache[1] = _createTextVNode(": "))
            ]),
            _createElementVNode("div", _hoisted_7, _toDisplayString(_ctx.avgTime) + " min ", 1)
          ]))
        : _createCommentVNode("", true),
      (!_ctx.modalData.last_status)
        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
            _createVNode(_component_translated_text_component, { translation: "traffic_no_last_data" })
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}